import {toast} from "react-toastify";

export const handlerError = (data, fn) => {
    toast.error(data?.data?.error || 'Ошибка!', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    fn([])
}

export const handleErrorConfirm = (text) => {
    toast.error(text, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
}
